<script setup>
import { onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';

// M06: minimal per-agent activity digest — what your employee actually did
// today and over the last 7 days, plus tool errors and spend.
const props = defineProps({
  brainId: {
    type: [Number, String],
    required: true,
  },
});

const { t } = useI18n();
const store = useStore();

const activity = ref(null);

onMounted(async () => {
  try {
    activity.value = await store.dispatch(
      'aiAgentBrains/activity',
      props.brainId
    );
  } catch (error) {
    // summary is informative only — keep the header usable without it
    activity.value = null;
  }
});
</script>

<template>
  <div
    v-if="activity"
    class="flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-n-slate-11"
  >
    <span>
      {{ t('AI_AGENTS.AGENT.ACTIVITY.TODAY') }}:
      {{ activity.today?.conversations_handled || 0 }}
      {{ t('AI_AGENTS.AGENT.ACTIVITY.CONVERSATIONS').toLowerCase() }} ·
      {{ activity.today?.handoffs || 0 }}
      {{ t('AI_AGENTS.AGENT.ACTIVITY.HANDOFFS').toLowerCase() }}
    </span>
    <span>
      {{ t('AI_AGENTS.AGENT.ACTIVITY.LAST_7_DAYS') }}:
      {{ activity.last_7_days?.conversations_handled || 0 }}
      {{ t('AI_AGENTS.AGENT.ACTIVITY.CONVERSATIONS').toLowerCase() }} ·
      {{ activity.last_7_days?.handoffs || 0 }}
      {{ t('AI_AGENTS.AGENT.ACTIVITY.HANDOFFS').toLowerCase() }}
    </span>
    <span>
      {{ t('AI_AGENTS.AGENT.ACTIVITY.TOOL_ERRORS') }}:
      {{ activity.tool_errors_today || 0 }}
    </span>
    <span>
      {{ t('AI_AGENTS.AGENT.ACTIVITY.SPEND') }}:
      {{ activity.spend?.current_usd || 0 }} /
      {{ activity.spend?.cap_usd || 0 }} USD
    </span>
    <span
      v-if="activity.spend?.over_cap"
      class="px-2 py-0.5 font-semibold rounded-full bg-n-ruby-9 text-white"
    >
      {{ t('AI_AGENTS.AGENT.ACTIVITY.OVER_CAP') }}
    </span>
  </div>
</template>
